<template>
  <hr class="h-2 w-70 bg-current border-none" />
</template>
